import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'regenerator-runtime';
import { Analytics } from 'fif-common-analytics';

import * as ENV_PROD from './environments/environment.prod';
import * as ENV_QA from './environments/environment.qa';

export declare const ENV_SUFFIXES: {
  test: string;
  qa: string;
  prod: string;
};

(async () => {
  if (!environment.isWc && !environment.isLocal) {
    if (environment.mode !== 'WEB-PF') {
      const response = await fetch('assets/app-config.json');
      const json = await response.json();

      const env = json.env;

      if (env === 'qa') {
        Object.assign(environment, ENV_QA.environment);
      } else if (env === 'prod') {
        Object.assign(environment, ENV_PROD.environment);
      }
    }
    const ProvidersReady = Analytics.TaggingAdapter.dynamicallyLoadProvider(environment.GA_ENV as keyof typeof ENV_SUFFIXES, 'BFPE_WEB');

    if (environment.production) {
      if (window) {
        window.console.log = () => { };
        window.console.info = () => { };
        window.console.error = () => { };
      }
    }
  }
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch((err) => console.error(err));
})();
